@if (HasRequiredPermissions) {
  @if (hasWebSocketChanges()) {
    <div class="absolute top-[3.2em] right-[1.5em] px-3 py-0 bg-yellow-50 border border-yellow-500 rounded-lg flex items-center justify-between z-50">
      <span class="text-xs text-yellow-800">
        {{ 'Record ' | translate }} {{ 'modified' | translate }}.
        ({{ totalModifiedCount() }} {{ 'changes' | translate }})
      </span>
    </div>
  }
  @if (EntityInstance || isNew()) {
    <!-- Conteneur principal avec layout flexbox -->
    <div [fieldContext]="this" class="flex flex-col h-full">
      <!-- Titre fixe en dehors de la zone de défilement -->
      <div class="px-6 pt-4 pb-2">
        <h4 class="text-[0.9em] font-medium text-gray-500 z-[999]">
          @if (isNew()) {
            {{ 'entities.truckerActivity.newEntity' | translate }}
          } @else {
            {{ 'entities.truckerActivity.detailEntity' | translate }}
          }
        </h4>
        <div class="flex justify-between items-center">
          <button (click)="cancelEdit()" data-testid="detail-close" class="absolute top-2 right-2 text-gray-500 hover:text-gray-700 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      <!-- Zone de contenu avec défilement -->
      <div #scrollContainer class="{{Skin.detailContainer}} flex-1 overflow-auto">
        <!--  Conteneur desactivable -->
        <div class="{{this.UpdateMode}}">
          <!-- Activity Information Section -->
          <div class="">
            <h3 class="{{Skin.formSectionSmallTitle}}">
              <i class="fa fa-user mr-2"></i> {{
              'vues.truckerActivity.detail.sections.activity-info' | translate
              }}
            </h3>
            <div class="space-y-2">
              <!-- Photo Upload (inchangé, spécifique) -->
              <div class="relative m-6 w-[140px] h-[180px] mt-2 ml-16 border border-gray-300 overflow-hidden rounded-[10px] border-[3px] border-gray-100 shadow-[0_7px_7px_rgba(0,0,0,0.1)]">
                <i class="far fa-user absolute inset-0 text-gray-400 text-[120px] flex items-center justify-center pointer-events-none" [ngClass]="{'hidden': imageUrl}"></i>
                <img [src]="imageUrl || ''" class="w-full h-full object-cover" [ngClass]="{'hidden': !imageUrl}" />
                <div class="absolute bottom-0 left-0 flex">
                  <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event,'FK_Image_Photo')" class="hidden" />
                  <button type="button" (click)="fileInput.click()" class="bg-teal-500 hover:bg-teal-800 text-white px-2 py-1 text-xs font-xs">
                    <i class="fa fa-camera text-[0.9rem]"></i>
                  </button>
                  <button type="button" (click)="resetImage()" class="{{Skin.btnAlert}} px-2 py-1 text-xs font-xs">
                    <i class="fas fa-times text-[0.9rem]"></i>
                  </button>
                </div>
              </div>
              <!-- Champ selectedPK_Pos (multi-select) -->
              <app-field-wrapper property="selectedPK_Pos" businessProperty="fK_POS" label="entities.account.propreties.pos">
                <app-multi-select #multiSelect
                  [options]="pointOfServiceLookup()"
                  [placeholder]="'Select Sites'"
                  [maxItems]="1"
                  [isMultiselect]="false"
                  [selectedKeys]="editingEntity()?.selectedPK_Pos ?? []"
                  (selectedKeysChange)="onPOSselectChange($event)"
                  onReady
                  (autoBind)="bindingHandler($event, 'selectedPK_Pos', multiSelect)">
                </app-multi-select>
              </app-field-wrapper>
              <!-- Champ truckerActivityID (readonly, généré côté serveur comme visitId) -->
              <app-field-wrapper property="truckerActivityID" label="entities.truckerActivity.propreties.id">
                <input type="text" readonly
                  [readonly]="true"
                  onReady
                  class="{{Skin.formInputSmallSize}} w-full border border-gray-400 p-2 rounded-[6px] bg-gray-100 readonly:pointer-events-none"
                  (autoBind)="bindingHandler($event, 'truckerActivityID')">
                </app-field-wrapper>
                <!-- Champ title -->
                <app-field-wrapper property="title">
                  <input type="text" autocomplete="off" onReady

                    class="{{Skin.formInputSmallSize}}"
                    (autoBind)="bindingHandler($event, 'title')">
                  </app-field-wrapper>
                  <!-- Champ deliveryType (reactive-badge) -->
                  <app-field-wrapper property="deliveryType">
                    <app-reactive-badge [status]="$safeNavigationMigration(editingEntity()?.deliveryType)"
                      [lookupData]="activityDeliveryTypeLookup()"
                      [Skin]="Skin"
                      [isEditMode]="true"
                      (statusChange)="onDeliveryTypeChange($event)">
                    </app-reactive-badge>
                  </app-field-wrapper>
                  <!-- Champ fK_Trucker (select) -->
                  <app-field-wrapper property="selectedPK_Trucker" businessProperty="fK_Trucker" label="entities.truckerActivity.propreties.trucker">
                    <app-multi-select #multiSelectTrucker
                      [options]="filteredTruckerLookup()"
                      [placeholder]="'choose-trucker'"
                      [maxItems]="1"
                      [isMultiselect]="false"
                      onReady
                      (autoBind)="bindingHandler($event, 'selectedPK_Trucker', multiSelectTrucker)"
                      [selectedKeys]="editingEntity()?.selectedPK_Trucker ?? []"
                      (selectedKeysChange)="onTruckerselectChange($event)">
                    </app-multi-select>
                  </app-field-wrapper>
                  <!-- Champ trailerNumber -->
                  <app-field-wrapper property="trailerNumber">
                    <input type="text" autocomplete="off" onReady

                      class="{{Skin.formInputSmallSize}}"
                      (autoBind)="bindingHandler($event, 'trailerNumber')">
                    </app-field-wrapper>
                  </div>
                </div>
                <!-- Schedule Information Section -->
                <div class="mt-10">
                  <h3 class="{{Skin.formSectionSmallTitle}}">
                    <i class="fa fa-calendar mr-2"></i> {{
                    'vues.truckerActivity.detail.sections.schedule-info' | translate
                    }}
                  </h3>
                  <div class="space-y-2">
                    <!-- Champ startDate -->
                    <!--<app-field-wrapper property="startDate">
                    <input #dt type="datetime-local" autocomplete="off" onReady

                      class="{{Skin.formInputSmallSize}}"
                      (autoBind)="bindingHandler($event, 'startDate')">
                    </app-field-wrapper>-->
                    <!-- Champ endDate -->
                    <!--<app-field-wrapper property="endDate">
                    <input type="datetime-local" autocomplete="off" onReady

                      class="{{Skin.formInputSmallSize}}"
                      (autoBind)="bindingHandler($event, 'endDate')">
                    </app-field-wrapper>-->
                    <!-- Start Date -->
                    <app-field-wrapper property="startDate">
                      <!--[timeFormat]="'12h'"-->
                      <app-date-time-picker onReady
                        [siteTimeZone]="fuseauDuSite"
                        [selectedDateTime]="editingEntity()?.startDate ?? null"
                        [calendarAlign]="'bottom-left'"
                        [disabled]="!editingEntity()?.selectedPK_Pos?.length || !isPosSelected()"
                        (dateTimeChange)="onDateTimePropretyChange($event, 'startDate')"
                        class="{{Skin.formInputSmallSize}} block bg-white"
                        (autoBind)="bindingHandler($event, 'startDate')">
                      </app-date-time-picker>
                    </app-field-wrapper>
                    <!-- End Date -->
                    <app-field-wrapper property="endDate">
                      <app-date-time-picker onReady
                        [siteTimeZone]="fuseauDuSite"
                        [selectedDateTime]="editingEntity()?.endDate ?? null"
                        [timeFormat]="'24h'"
                        [calendarAlign]="'bottom-left'"
                        [disabled]="!editingEntity()?.selectedPK_Pos?.length || !isPosSelected()"
                        (dateTimeChange)="onDateTimePropretyChange($event, 'endDate')"
                        class="{{Skin.formInputSmallSize}} block bg-white"
                        (autoBind)="bindingHandler($event, 'endDate')">
                      </app-date-time-picker>
                    </app-field-wrapper>
                    <!-- Champ status (reactive-badge) -->
                    <app-field-wrapper property="status">
                      <app-reactive-badge [status]="$safeNavigationMigration(editingEntity()?.status)"
                        [lookupData]="activityStatusLookup()"
                        [Skin]="Skin"
                        [isEditMode]="true"
                        (statusChange)="onStatusChange($event)">
                      </app-reactive-badge>
                    </app-field-wrapper>
                    <!-- Champ fK_Dock (select) -->
                    <app-field-wrapper property="fK_Dock">
                      <select onReady

                        class="{{Skin.formInputSmallSize}}"
                        (autoBind)="bindingHandler($event, 'fK_Dock')">
                        <option [value]="null">{{ 'Choose a dock' | translate }}</option>
                        @for (dockOption of filteredDockLookup(); track dockOption.key) {
                          <option [value]="dockOption.key">
                            {{ dockOption.value }} ({{ dockOption.additionalData['dockstatusname'] | translate }})
                          </option>
                        }
                      </select>
                    </app-field-wrapper>
                  </div>
                </div>
                <!-- Delivery Information Section -->
                <div class="mt-10">
                  <h3 class="{{Skin.formSectionSmallTitle}}">
                    <i class="fas fa-truck mr-2"></i> {{
                    'vues.truckerActivity.detail.sections.delivery-info' | translate
                    }}
                  </h3>
                  <div class="space-y-2">
                    <!-- Champ billOfLanding -->
                    <app-field-wrapper property="billOfLanding">
                      <input type="text" autocomplete="off" onReady

                        class="{{Skin.formInputSmallSize}}"
                        (autoBind)="bindingHandler($event, 'billOfLanding')">
                      </app-field-wrapper>
                      <!-- Champ sCACCode -->
                      <app-field-wrapper property="sCACCode">
                        <input type="text" autocomplete="off" onReady

                          class="{{Skin.formInputSmallSize}}"
                          (autoBind)="bindingHandler($event, 'sCACCode')">
                        </app-field-wrapper>
                        <!-- Champ portOfEntry -->
                        <app-field-wrapper property="portOfEntry">
                          <input type="text" autocomplete="off" onReady

                            class="{{Skin.formInputSmallSize}}"
                            (autoBind)="bindingHandler($event, 'portOfEntry')">
                          </app-field-wrapper>
                          <!-- Champ licenceNumber -->
                          <app-field-wrapper property="licenceNumber">
                            <input type="text" autocomplete="off" onReady

                              class="{{Skin.formInputSmallSize}}"
                              (autoBind)="bindingHandler($event, 'licenceNumber')">
                            </app-field-wrapper>
                          </div>
                        </div>
                        <!-- Documents / Attachments Section -->
                        <div class="mt-10">
                          <h3 class="{{Skin.formSectionSmallTitle}}">
                            <i class="fas fa-paperclip mr-2"></i> {{
                            'vues.truckerActivity.detail.sections.documents' | translate
                            }}
                          </h3>
                          <div class="space-y-2">
                            <app-download-document [attachments]="$safeNavigationMigration(editingEntity()?.attachments)"></app-download-document>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Bandeau pour le nombre d'erreurs -->
                    @if (generalErrorCount() > 0) {
                      <div class="mb-1 p-1 bg-orange-100 text-red-700 border border-orange-300 rounded-full text-xs sticky bottom-14 z-10 py-1 -mt-1 z-20 text-center">
                        <i class="fas fa-exclamation-triangle mr-1 ml-2"></i>
                        {{ generalErrorCount() }} erreur(s) dans le formulaire
                      </div>
                    }
                    <!-- Boutons en bas du formulaire -->
                    <div class="bg-stone-50 min-w-full flex space-x-1 justify-center pt-2 border-t border-gray-200">
                      @if (HasEditPermission) {
                        <button name="SaveButton" data-testid="detail-save"
                          type="button" (click)="saveItem()"
                          [disabled]="!isFormValid()"
                          class="{{Skin.btnPrimary}} uppercase py-2 px-2">
                          <i class="far fa-check-square mr-2"></i>
                          {{ 'buttons.save' | translate }}
                        </button>
                      }
                      @if (HasEditPermission) {
                        <button name="SaveAndCloseButton" data-testid="detail-save-close"
                          type="button" (click)="saveAndCloseItem()"
                          [disabled]="!isFormValid()"
                          class="{{Skin.btnPrimary}} uppercase py-2 px-2">
                          <i class="far fa-check-square mr-2"></i>
                          {{ 'buttons.save-and-close' | translate }}
                        </button>
                      }
                      <button (click)="cancelEdit()" data-testid="detail-cancel" class="{{Skin.btnAlert}} uppercase py-2 px-2">
                        <i class="fas fa-times mr-2"></i>
                        {{ 'buttons.cancel' | translate }}
                      </button>
                    </div>
                  </div>
                }
              }
